import React, { useEffect, useState } from "react";

// Custom Components
import Author from "components/Table/Author";
import MDBox from "components/MDBox";
import { Checkbox, IconButton } from "@mui/material";

// Redux
import { exportToolBoxTalkPdfStreamed } from "redux/Thunks/toolBoxTalk";

// Constants
import Constants, { Icons, defaultData, Colors } from "utils/Constants";

// 3rd party library
import moment from "moment";

// Methods
import { getFormattedProjectName } from "utils/methods/methods";

const ToolboxTalkData = (
  toolboxData,
  handleOpenToolboxDrawer,
  handleOpenDeleteModal,
  handlePdfExportFromHOC,
  selectedIds,
  handleSelectRow,
  isSelectMode,
  handleSelectAll,
  isAllSelected
) => {
  const [exportToolboxId, setExportToolboxId] = useState(null);
  const [rows, setRows] = useState([]);

  const handleExportToolbox = async (id) => {
    setExportToolboxId(id);
    const body = { toolboxId: id };
    await handlePdfExportFromHOC("ToolboxTalk", exportToolBoxTalkPdfStreamed(body));
    setExportToolboxId(null);
  };

  useEffect(() => {
    if (toolboxData) {
      const dataList = toolboxData?.map((item, index) => {
        const id = item?.[Constants.MONGOOSE_ID];
        const isSelected = selectedIds ? selectedIds.has(id) : false;
        return {
          select:
            isSelectMode && id ? (
              <Checkbox
                size="small"
                checked={isSelected}
                onChange={() => handleSelectRow && handleSelectRow(id)}
                onClick={(e) => e.stopPropagation()}
                sx={{ color: Colors.BLACK, padding: 0 }}
              />
            ) : null,
          no: <Author name={index + 1} />,
          project: (
            <Author
              name={getFormattedProjectName(item?.project) || Constants.NA}
              maxContent={defaultData.MEDIUM_CONTENT_LENGTH}
            />
          ),
          location: (
            <Author
              name={item?.location?.title || Constants.NA}
              maxContent={defaultData.MEDIUM_CONTENT_LENGTH_2}
            />
          ),
          team: <Author name={item?.team?.teamsWfmName || Constants.NA} />,
          attendee: <Author name={`${item?.memberSigned || Constants.NA}`} />,
          submittedat: (
            <Author
              name={moment(item?.createdAt).format(defaultData.WEB_24_HOURS_FORMAT_WITHOUT_SECOND)}
            />
          ),
          host: (
            <Author
              name={
                `${
                  (item?.createdBy?.callingName
                    ? item?.createdBy?.callingName
                    : item?.createdBy?.firstName) ?? ""
                } ${item?.createdBy?.lastName ?? ""}`.trim() || Constants.NA
              }
            />
          ),
          note: (
            <Author
              name={item?.note || Constants.NA}
              maxContent={defaultData.LARGE_CONTENT_LENGTH}
            />
          ),
          action: (
            <MDBox>
              <IconButton
                aria-label="report-parameter"
                color="info"
                onClick={() => handleOpenToolboxDrawer(item[Constants.MONGOOSE_ID])}
              >
                {Icons.VIEW}
              </IconButton>
              <IconButton
                aria-label="report-parameter"
                color="info"
                onClick={() => handleOpenDeleteModal(item[Constants.MONGOOSE_ID])}
              >
                {Icons.DELETE}
              </IconButton>
              &nbsp;
              <IconButton
                aria-label="Export Safety Card"
                color="info"
                onClick={() => handleExportToolbox(item[Constants.MONGOOSE_ID])}
              >
                {exportToolboxId === item[Constants.MONGOOSE_ID] ? Icons.LOADING : Icons.EXPORT}
              </IconButton>
            </MDBox>
          ),
        };
      });

      setRows(dataList);
    }
  }, [toolboxData, exportToolboxId, selectedIds, isSelectMode]);

  return {
    columns: [
      ...(isSelectMode
        ? [
            {
              Header: () => (
                <MDBox display="flex" justifyContent="center" alignItems="center" width="100%">
                  <Checkbox
                    size="small"
                    checked={isAllSelected}
                    onChange={handleSelectAll}
                    onClick={(e) => e.stopPropagation()}
                    sx={{ color: Colors.WHITE, padding: 0 }}
                  />
                </MDBox>
              ),
              accessor: "select",
              width: "2%",
              disableSortBy: true,
            },
          ]
        : []),
      { Header: "No.", accessor: "no", width: "2%" },
      { Header: "Project", accessor: "project", align: "left", width: "18%" },
      { Header: "Location", accessor: "location", align: "left", width: "12%" },
      { Header: "Team", accessor: "team", align: "left", width: "8%" },
      { Header: "Attendee", accessor: "attendee", align: "center", width: "8%" },
      { Header: "Submitted At", accessor: "submittedat", align: "left", width: "8%" },
      { Header: "Host", accessor: "host", align: "left", width: "10%" },
      { Header: "Note", accessor: "note", align: "left", width: "30%" },
      { Header: "Action", accessor: "action", align: "left", width: "15%" },
    ],
    rows,
  };
};

export default ToolboxTalkData;
